module.exports = __webpack_public_path__ + "img/premium_art-explore_art.a1e21bc7.jpg";